import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";
import { SvgIcon } from "../SvgIcon";

export function GameStopSymbol({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("GameStopSymbol");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 48 48"
      sx={mergeSx({ w: "100px", fill: "base.color.text.body.primary" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

GameStopSymbol.displayName = "GameStopSymbol";
